import { IPassportSchema } from '@/pages/MDM/mdm.types.ts'
import { useMemo } from 'react'
import usePassportSchemas from '@/pages/MDM/hooks/usePassportSchemas.ts'
import DropdownInput from 'src/shared/Inputs/DropdownInput'

interface IProps {
  value: IPassportSchema['id']
  name: string
  onChange: (val: IPassportSchema['id'], name: string) => void
}

const PassportSchemaDropdown = (props: IProps) => {
  const passportSchemas = usePassportSchemas()

  const options = useMemo(() => {
    return passportSchemas.map((v) => ({ title: v.name, value: v.id }))
  }, [passportSchemas])

  return (
    <DropdownInput
      options={options}
      name={props.name}
      selectedOption={props.value as any}
      title="Выберите схему паспорта"
      onSelect={props.onChange}
    />
  )
}

export default PassportSchemaDropdown
